import { apiClient } from './api'

/**
 * Notification type from API
 */
export interface Notification {
  id: string
  _id: string
  userId: string
  title: string
  message: string
  type: 'info' | 'warning' | 'error' | 'success' | 'task' | 'recommendation'
  isRead: boolean
  readAt?: string
  relatedEntity?: {
    type: 'task' | 'recommendation' | 'yard' | 'alert' | 'user'
    id: string
  }
  metadata?: any
  createdAt: string
  updatedAt: string
}

/**
 * Paginated notifications response
 */
export interface NotificationsResponse {
  notifications: Notification[]
  pagination: {
    page: number
    limit: number
    total: number
    pages: number
  }
}

/**
 * Gets paginated notifications for the current user
 * @param params - Optional filter parameters
 * @returns Promise with paginated notifications
 */
export function getNotifications(params?: { isRead?: boolean; type?: string; page?: number; limit?: number }) {
  return apiClient.get<NotificationsResponse>('/notifications', { params })
}

/**
 * Gets count of unread notifications
 * @returns Promise with unread count
 */
export function getUnreadCount() {
  return apiClient.get<{ count: number }>('/notifications/unread-count')
}

/**
 * Marks a single notification as read
 * @param id - Notification ID
 * @returns Promise with updated notification
 */
export function markAsRead(id: string) {
  return apiClient.put(`/notifications/${id}/read`)
}

/**
 * Marks all notifications as read
 * @returns Promise with result
 */
export function markAllAsRead() {
  return apiClient.put('/notifications/read-all')
}

/**
 * Deletes a notification
 * @param id - Notification ID
 * @returns Promise with result
 */
export function deleteNotification(id: string) {
  return apiClient.delete(`/notifications/${id}`)
}
